export const ProfileStats = ({ stats, isCreator }) => {
  const items = [
    { label: "Followers", value: stats.followers },
    { label: "Following", value: stats.following },
    ...(isCreator ? [{ label: "Tracks", value: stats.tracks }, { label: "Videos", value: stats.videos }] : []),
  ];
  return (
    <div className={`grid ${isCreator ? "grid-cols-4" : "grid-cols-2"} divide-x divide-white/10 rounded-2xl border border-white/10 bg-nw-surface/60`}>
      {items.map(({ label, value }) => (
        <div key={label} className="py-4 text-center" data-testid={`profile-stat-${label.toLowerCase()}`}>
          <p className="font-display text-xl font-bold text-white">{value}</p>
          <p className="text-[10px] uppercase tracking-widest text-slate-500">{label}</p>
        </div>
      ))}
    </div>
  );
};
